import { BILLING_TARIFF_ALIAS } from '@/features/billing/consts/tariff'
import { User } from '../../types'

export const hasSubscription = (user: User | null) => {
  return user?.tariff?.alias !== BILLING_TARIFF_ALIAS.FREE
}
